import { Context } from 'Context/Context';
import React, { useContext, useEffect, useState } from 'react'

function ReqToCloseBtns({caseDetails, setShowModal, onRevert, userInfo}) {
    const [seeIfreqRevCountArr, setSeeIfreqRevCountArr] = useState(null);
    const {reqRevCountArr} = useContext(Context);
    useEffect(() => {
      setSeeIfreqRevCountArr(reqRevCountArr?.[caseDetails?.caseDetails?._id]?.reqToClose);
    }, [reqRevCountArr]);
  return (
        <div className='flex w-full lg:w-max justify-center bg-white text-xs lg:text-sm '>
        <div className='flex w-full lg:w-max justify-between '>
        {
        (caseDetails.caseStatus === "reqToClose" ? 
        (caseDetails?.userId === userInfo?._id ?
        <div
        className='rounded cursor-pointer justify-center lg:mr-2 text-white bg-green-700 px-4 p-2 w-full lg:w-max flex items-end'
        onClick={onRevert}
        >
           Move back to - My Active Cases
        </div>
        :
        <div>
          {/* this was requested by team up so no move back button */}
          </div>)
        :
            
        (seeIfreqRevCountArr 
        ?
        <div 
         className='rounded lg:mr-2 text-white justify-center opacity-50 cursor-none bg-green-700 px-4 p-2 w-full lg:w-max flex items-end'>

                Someone requested to close this case
        </div>
        :
        <div 
        onClick={()=> setShowModal(true)}
        className='rounded lg:mr-2  justify-center text-white bg-green-700 px-4 p-2 w-full lg:w-max flex items-end cursor-pointer'>
                Request to close case
            
        </div>
        )
        )
        }
        </div>
        </div>
  )
}

export default ReqToCloseBtns